import { Icon } from "@iconify/react/dist/iconify.js";
import "datatables.net-dt/js/dataTables.dataTables.js";
import Papa from "papaparse";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import ".././components/CSS/Crm.css";
import sample_customer from "../Assets/sample_customer.csv";
import UserIconOrenge from "../Assets/UserIconOrenge.svg";
import { handleError, handleSuccess } from "../CommonJquery/CommonJquery";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/child/AddUserLayer";
import UnitCountTwo from "../components/child/UnitCountTwo";
import MasterLayout from "../masterLayout/MasterLayout";
import Gmail from "../Assets/gmail.png";
import Phone from "../Assets/telephone.png";
import whatsapp from "../Assets/whatsapp.png";
import { useMasterData } from "../masterLayout/MasterLayout";
import {
  delete_new_users,
  save_customer_bulk,
  server_post_data,
  sms_dashboard,
} from "../ServiceConnection/serviceconnection";
import Loader from "./Loader";
import $ from "jquery";
import { retrieveData } from "../LocalConnection/LocalConnection";

let click_time = 0;

function CRMContent() {
  const { showEmailForm } = useMasterData(); // "0" or "1"

  const tableRef = useRef(null);

  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [showView, setShowView] = useState(false);
  const [viewId, setViewId] = useState(null);
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [CustomerTotal, setCustomerTotal] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(false);
  const periodSelected = retrieveData("period");

  const handleModalClose = () => setShowModal(false);

  const handleModalOpen = (index) => {
    setSelectedItem(CustomerTotal.customer_list[index]);
    setShowModal(true);
  };

  const handleDateSelection = (start, end, period) => {
    setCustomerTotal([]);
    master_data_get(start, end, period);
  };

  const master_data_get = async (start, end, period) => {
    setShowLoaderAdmin(true);
    let formdata = new FormData();
    formdata.append("from_date", start);
    formdata.append("to_date", end);
    formdata.append("click_type", period);
    await server_post_data(sms_dashboard, formdata)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          setCustomerTotal(final_data);
          setData(final_data.customer_list || []);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };

  useEffect(() => {
    master_data_get("", "", periodSelected);
  }, []);

  const handleClose = () => setShow(false);
  const handleCloseView = () => setShowView(false);
  const handleShow = (index) => {
    setViewId(index);
    setShow(true);
  };
  const handleShowView = (index) => {
    setViewId(index);
    setShowView(true);
  };

  const handleSampleDownload = () => {
    const link = document.createElement("a");
    link.href = sample_customer;
    link.download = "sample_customer";
    link.click();
  };

  const handleUploadCsv = () => {
    document.getElementById("csv-file-input").click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file && file.name.endsWith(".csv")) {
      const reader = new FileReader();
      reader.onload = () => {
        Papa.parse(reader.result, { header: true });
      };
      reader.onerror = (error) => console.error("Error reading file:", error);
      reader.readAsText(file);

      setShowLoaderAdmin(true);
      let fd_from = new FormData();
      fd_from.append("upload_bank_statement", file);
      await server_post_data(save_customer_bulk, fd_from)
        .then((Response) => {
          setShowLoaderAdmin(false);
          let data1 = Response.message.split("~@~");
          if (parseInt(data1[0]) === 1) {
            handleError(data1[1]);
          } else {
            handleSuccess("File Successfully Uploaded");
            master_data_get("", "", 1);
          }
        })
        .catch((error) => {
          console.log(error);
          setShowLoaderAdmin(false);
        });
    } else {
      handleError("Please upload a valid CSV file!");
    }
  };

  const handleSubmit = async (id) => {
    if (click_time === 0) {
      setShowLoaderAdmin(true);
      click_time = 1;
      let fd_from = new FormData();
      fd_from.append("id", id);
      await server_post_data(delete_new_users, fd_from)
        .then((Response) => {
          setShowLoaderAdmin(false);
          let data1 = Response.message.split("~@~");
          if (parseInt(data1[0]) === 1) {
            handleError(data1[1]);
          } else {
            handleModalClose();
            master_data_get("", "", 1);
            click_time = 0;
            handleSuccess("Successfully Deleted");
          }
        })
        .catch((error) => {
          click_time = 0;
          console.log(error);
          setShowLoaderAdmin(false);
        });
    }
  };

  // Fixed DataTables initialization with delayed column adjust
  useEffect(() => {
    if (
      CustomerTotal &&
      CustomerTotal.customer_list &&
      CustomerTotal.customer_list.length > 0
    ) {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }

      const table = $(tableRef.current).DataTable({
        pageLength: 10,
        destroy: true,
      });

      // Delay the adjust to ensure DOM is ready and visible
      setTimeout(() => {
        table.columns.adjust().draw(false); // false = keep current page
      }, 100);
    }

    return () => {
      if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [CustomerTotal.customer_list]);

  return (
    <>
      {ShowLoaderAdmin && <Loader />}
      <Breadcrumb title="CRM" onDateSelection={handleDateSelection} />
      <div className="crm_div_contr">
        {CustomerTotal && CustomerTotal.total_customer && (
          <UnitCountTwo
            CustomerTotal={CustomerTotal}
            total_customer={CustomerTotal.total_customer.total_count}
            total_new_customer={CustomerTotal.total_new_customer.total_count}
            total_customer_positive={
              CustomerTotal.total_customer_positive.total_count
            }
            total_customer_positive_last={
              CustomerTotal.total_customer_positive_last.total_count
            }
            total_new_customer_negative={
              CustomerTotal.total_new_customer_negative.total_count
            }
            total_new_customer_negative_last={
              CustomerTotal.total_new_customer_negative_last.total_count
            }
            total_reviews_new_customer_data={
              CustomerTotal.total_reviews_new_customer_data.total_count
            }
            total_reviews_new_customer_data_late={
              CustomerTotal.total_reviews_new_customer_data_late.total_count
            }
            total_click_type={CustomerTotal.click_type}
          />
        )}

        {/* Upload Div */}
        <div className="card basic-data-table mt-3">
          <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
            <div className="d-flex flex-column MarGinClass">
              <h5 className="card-title mb-0">Upload Customer Data</h5>
              <p className="NoteUploadData">You can upload the bulk data</p>
            </div>
            <div className="uploadCSVCOnt">
              <div
                className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2 sampleDownload"
                onClick={handleSampleDownload}
              >
                <Icon
                  icon="ic:baseline-download"
                  className="icon text-xl line-height-1"
                />
                Sample Download
              </div>
              <div
                className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2 sampleDownload"
                onClick={handleUploadCsv}
              >
                <Icon
                  icon="ic:baseline-upload"
                  className="icon text-xl line-height-1"
                />
                Upload CSV
              </div>
              <input
                id="csv-file-input"
                type="file"
                accept=".csv"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>
          </div>
        </div>

        {/* Customers Table */}
        <div className="card basic-data-table mt-3">
          <div className="card-header d-flex justify-content-between align-items-center cusdataDiv">
            <h5 className="card-title mb-0">Customers</h5>
            <div
              className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2 BtnssCustumdata"
              onClick={() => handleShow("Direct")}
            >
              <Icon
                icon="ic:baseline-plus"
                className="icon text-xl line-height-1"
              />
              Add Customer
            </div>
          </div>

          <div
            className="card-body"
            style={{ width: "100%", overflowX: "scroll" }}
          >
            {CustomerTotal && CustomerTotal.customer_list && (
              <table
                ref={tableRef}
                className="table bordered-table mb-0"
                id="dataTable"
              >
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    {showEmailForm !== "0" && <th scope="col">Email</th>}
                    <th scope="col">Mobile</th>
                    <th scope="col">Last Review</th>
                    <th scope="col">Contact</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {CustomerTotal.customer_list.map((customer, index) => (
                    <tr key={customer.bus_cus_id}>
                      <td>{`#${customer.bus_cus_id}`}</td>
                      <td>{customer.name_user}</td>
                      {showEmailForm !== "0" && (
                        <td>{customer.email || "-"}</td>
                      )}
                      <td>{customer.contact_no}</td>
                      <td>
                        {customer.gender === null
                          ? " "
                          : customer.gender?.slice(0, 15) + "..."}
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-10 ">
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              window.location.href = `tel:${customer.contact_no}`;
                            }}
                          >
                            <img
                              style={{ width: "24px" }}
                              src={Phone}
                              alt="Call"
                            />
                          </button>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              const message =
                                "Hello! I would like to get in touch.";
                              const url = `https://wa.me/${
                                customer.contact_no
                              }?text=${encodeURIComponent(message)}`;
                              window.open(url, "_blank");
                            }}
                          >
                            <img
                              style={{ width: "24px" }}
                              src={whatsapp}
                              alt="WhatsApp"
                            />
                          </button>
                          {showEmailForm !== "0" && customer.email && (
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                const subject = "Wowreviews";
                                const body =
                                  "Hello, I would like to discuss something.";
                                const url = `mailto:${
                                  customer.email
                                }?subject=${encodeURIComponent(
                                  subject,
                                )}&body=${encodeURIComponent(body)}`;
                                window.open(url, "_blank");
                              }}
                            >
                              <img
                                style={{ width: "24px" }}
                                src={Gmail}
                                alt="Email"
                              />
                            </button>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-10 ">
                          <button
                            type="button"
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => handleShowView(customer)}
                          >
                            <Icon
                              icon="majesticons:eye-line"
                              className="icon text-xl"
                            />
                          </button>
                          <button
                            type="button"
                            className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => handleShow(customer)}
                          >
                            <Icon icon="lucide:edit" className="menu-icon" />
                          </button>
                          <button
                            type="button"
                            className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => handleModalOpen(index)}
                          >
                            <Icon
                              icon="fluent:delete-24-regular"
                              className="menu-icon"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* Modals */}
        <Modal show={show} onHide={handleClose}>
          <AddUserLayer
            viewId={viewId}
            masterGet={master_data_get}
            handleClose={handleClose}
          />
        </Modal>

        <Modal show={showView} onHide={handleCloseView}>
          {viewId && viewId != null && (
            <div className="card h-100 p-0 radius-12">
              <div className="card-body p-24">
                <div className="row justify-content-center">
                  <div className="col-xxl-12 col-xl-12 col-lg-12">
                    <div className="card border">
                      <div className="card-body">
                        <h5 className="text-lg text-primary-light mb-16">
                          Customer Details
                        </h5>
                        <form>
                          <div className="mb-20">
                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                              Full Name
                            </label>
                            <p>{viewId.name_user}</p>
                          </div>
                          {showEmailForm !== "0" && (
                            <div className="mb-20">
                              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                Email
                              </label>
                              <p>{viewId.email || "-"}</p>
                            </div>
                          )}
                          <div className="mb-20">
                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                              Phone
                            </label>
                            <p>{viewId.contact_no}</p>
                          </div>
                          <div className="mb-20">
                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                              Last Review
                            </label>
                            <p>
                              {viewId.latest_review_message || "No review yet"}
                            </p>
                          </div>
                          <div className="d-flex justify-content-center">
                            <button
                              type="button"
                              className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-50 py-11 radius-8"
                              onClick={handleCloseView}
                            >
                              Close
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>

        <Modal
          size="md"
          className="statusModal"
          centered
          show={showModal}
          onHide={handleModalClose}
        >
          <Modal.Body>
            <div className="statusContntDiv">
              <div className="d-flex flex-column align-items-center">
                <img src={UserIconOrenge} alt="Delete confirmation" />
                <p>Please confirm, do you want to delete?</p>
                {selectedItem && (
                  <label style={{ textAlign: "center" }}>
                    Name: {selectedItem.name_user}
                  </label>
                )}
              </div>
            </div>
          </Modal.Body>
          <div className="d-flex justify-content-center bttmnsStus">
            <button
              className="AddEventbutton CencelllBttn"
              onClick={handleModalClose}
            >
              Cancel
            </button>
            <button
              className="AddEventbutton Yesbttn"
              onClick={() => handleSubmit(selectedItem.bus_cus_id)}
            >
              Confirm
            </button>
          </div>
        </Modal>
      </div>
    </>
  );
}

function CRM() {
  return (
    <MasterLayout>
      <CRMContent />
    </MasterLayout>
  );
}

export default CRM;
